import React from 'react';
import styled from 'styled-components';
import StackedTable from '@grnhse/seedling/lib/azalea/components/stacked_table';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/DEPRECATED/components/form/layout'. 'app/webpack/javascripts/shared/DEPRECATED/components/form/layout.js' implicitly has an 'any' type.
import { FormField } from 'shared/DEPRECATED/components/form/layout';

import { standardRequest } from 'shared/utils/request';
import {
  ContentBody,
  ContentContainer,
  ContentDescription,
  ContentHeader,
  Loading,
  Required,
} from 'gdpr/components/components';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('gdpr');
type Item = {
  label: string;
  value: string | number;
  note?: string;
  disabled?: boolean;
};

type CandidateDatum = {
  label: string;
  options: Array<Item>;
};

type Props = {
  candidateDataPath: string;
  error: string | any;
  onDataToBeDeletedChange: (arg1: string, arg2: boolean) => void;
  selectedCandidateData: Array<string>;
};

type State = {
  candidateData: Array<CandidateDatum>;
  loaded: boolean;
};

type Response = {
  data: {
    candidate_data: Array<CandidateDatum>;
    selected_candidate_data: Array<Item>;
  };
};

export default class DataToBeDeleted extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      candidateData: [],
      loaded: false,
    };
  }

  componentDidMount() {
    this.loadCandidateData();
  }

  loadCandidateData = () => {
    standardRequest
      .get(this.props.candidateDataPath)
      .then(this.onCandidateData)
      
      .catch((error) => {
        console.log('Error loading candidate data.', error);
      });
  };

  onCandidateData = (response: Response) => {
    this.setState({
      candidateData: response.data.candidate_data,
      loaded: true,
    });
  };

  render() {
    const { candidateData } = this.state;
    const { error, selectedCandidateData, onDataToBeDeletedChange } =
      this.props;

    if (this.state.loaded) {
      return (
        <ContentContainer
          data-provides="data_to_be_deleted"
          data-ref="data-to-be-deleted-component"
        >
          <FormField error={error}>
            <ContentHeader>
              {t('data_to_be_deleted')} <Required />
            </ContentHeader>
            <ContentDescription>
              {t('data_to_be_deleted_description')}
            </ContentDescription>
            <ContentBody>
              <Container id="edit-candidate-data">
                <StackedTable
                  error={error}
                  toggleSelectedId={onDataToBeDeletedChange}
                  options={candidateData}
                  selected={selectedCandidateData}
                  height={'459px'}
                />
              </Container>
            </ContentBody>
          </FormField>
        </ContentContainer>
      );
    } else {
      return <Loading />;
    }
  }
}

const Container = styled.div`
  box-sizing: content-box;
  width: 75%;
`;
